export var milestones = [
  {
    'title': 'Milestone 1',
    'route': '#milestone-1',
    'blocks': [
      {'header': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'},
      {'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum..'},
      {
        'video': {
          'url': 'https://player.vimeo.com/video/483824462',
          'image': './static/PWLTD.jpg',
          'overlay': 'Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. '
        }
      },
      {'text': 'Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.'},
      {'text': '<b>In scelerisque sem at dolor.</b><br><br>Curabitur sodales ligula in libero. Sed dignissim lacinia nunc. Curabitur tortor. Pellentesque nibh. Aenean quam.'},
      {'text': '<b>Morbi lectus</b><br><br>Morbi lectus risus, iaculis vel, suscipit quis, luctus non, massa. Fusce ac turpis quis ligula lacinia aliquet. Mauris ipsum.'},
      {
        'pdfLinks': [
          {'filepath': './static/pdfs/example.pdf', 'title': 'Example\'s Letter'},
          {'filepath': './static/pdfs/example.pdf', 'title': 'Example Press'}
        ]
      }
    ]
  },
  {
    'title':
      'Milestone 2',
    'route':
      '#milestone-2',
    'blocks': [
      {'header': 'Nulla Metus Metus'},
      {
        'text': 'Quisque volutpat condimentum velit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nam nec ante. Sed lacinia, urna non tincidunt mattis, tortor neque adipiscing diam, a cursus ipsum ante quis turpis. Nulla facilisi. Ut fringilla. Suspendisse potenti. Nunc feugiat mi a tellus consequat imperdiet. Vestibulum sapien. Proin quam. Etiam ultrices. Suspendisse in justo eu magna luctus suscipit. Sed lectus. <a data-fancybox href="https://vimeo.com/483824462">Fancy Video here</a>.<br><br>\n' +
        'Quisque cursus, metus vitae pharetra auctor, sem massa mattis sem, at interdum magna augue eget diam. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Morbi lacinia molestie dui. <a href="./static/pdfs/example.pdf" target="_blank" download>Example PDF Letter</a>.'
      },
      {
        'pdfLinks': [
          {'filepath': './static/pdfs/example.pdf', 'title': 'Praesent Blandit Dolor'},
          {'filepath': './static/pdfs/example.pdf', 'title': 'Sed Non Quam.'}
        ]
      }
    ]
  },
  {
    'title':
      'Milestone 3',
    'route':
      '#milestone-3',
    'blocks': [
      {'header': 'Sed Non Quam.'},
      {'text': 'Quisque cursus, metus vitae pharetra auctor, sem massa mattis sem, at interdum magna augue eget diam. Vestibulum ante ipsum primis in faucibus orci luctus.'}
    ]
  },
  {
    'title':
      'Milestone 4',
    'route':
      '#milestone-4',
    'blocks': [
      {'header': 'In Vel Mi Sit '},
      {'text': 'Curabitur sodales ligula in libero. Sed dignissim lacinia nunc. Curabitur tortor. Pellentesque nibh. Aenean quam. In scelerisque sem at dolor. Maecenas mattis.'}
    ]
  },
  {
    'title':
      'Milestone 5',
    'route':
      '#milestone-5',
    'blocks': [
      {'header': 'Maecenas Mattis'},
      {'text': 'Vestibulum tincidunt malesuada tellus. Ut ultrices ultrices enim. Curabitur sit amet mauris. Morbi in dui quis est pulvinar ullamcorper.'}
    ]
  }
]



// WEBPACK FOOTER //
// ./src/global/milestones.js